import { Component, OnInit, Input } from '@angular/core';
import { Client } from '../../../interfaces/Client.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {

  public infoClient:Client;
  public volumen:string;
  public volumenView:boolean;
  public fidelidad:string;
  public fidelidadView:boolean;
  public mail:string;
  public mailHref:string;
  public imgsrc1:string;
  public imgsrc2:string;
  public aprov:boolean;
  public planCompromiso: string;
  public actualLanguage: string;
  public categoria:string;
  


  constructor(private _translate: TranslateService) {
    this.mail = '';
    this.mailHref = '';
    this.categoria='';
    this.volumenView=true;
    this.fidelidadView=true;
    this.aprov=false;
    if(sessionStorage.getItem('lang')){
      console.log("INSIDE");
      console.log(sessionStorage.getItem('lang'));
      this.actualLanguage = sessionStorage.getItem('lang');
    }
   }

  ngOnInit() {
    if(localStorage.getItem('infoClient')){
      this.infoClient=JSON.parse(localStorage.getItem('infoClient'));
    }
    
    setInterval(()=>{
    this.setStringCategory();
    },500);
  }


  public setStringCategory(){
    this.fidelidad='';
    this.volumen='';
    switch(this.infoClient.category.id){
      
      
      case '1':
          if(this.infoClient.level.id==='1'){
            this.volumenView=true;
            this.categoria= this._translate.get('ence.conditions-cat-emb').toString();
            this.fidelidadView=true;
            this.fidelidad="100%";
            this.volumen= this.infoClient.info.tons+" toneladas";
            
          }else if(this.infoClient.level.id==='2'){
            this.volumenView=true;
            this.categoria= this._translate.get('ence.conditions-cat-avn').toString();
            this.fidelidadView=false;
            this.volumen=this.infoClient.info.tons+" toneladas";
          }else if(this.infoClient.level.id==='3'){
            this.volumenView=true;
            this.categoria= this._translate.get('ence.conditions-cat-str').toString();
            this.fidelidadView=false;
            this.volumen=this.infoClient.info.tons+" toneladas";
          }
          this.mail = 'suministradores@ence.es';
          this.mailHref = 'mailto:suministradores@ence.es';
          if (this.actualLanguage == 'es') {
            this.planCompromiso = 'Plan compromiso volumen mensual';
          } else {
            this.planCompromiso = 'Plan de compromiso volume mensual';
          }
          
      break;
      case '2':
          if(this.infoClient.level.id==='4'){
            this.volumen=this.infoClient.info.tons+' toneladas';
            this.volumenView=true;
            this.categoria= this._translate.get('ence.conditions-cat-pt').toString();
            this.fidelidad='100%';
            this.fidelidadView=true;
          }else if(this.infoClient.level.id==='5'){
            this.volumenView=true;
            this.categoria= this._translate.get('ence.conditions-cat-orof').toString();
            this.fidelidadView=false;
            this.volumen=this.infoClient.info.tons+' toneladas';
          }else if(this.infoClient.level.id==='6'){
            this.volumenView=true;
            this.fidelidadView=true;
            this.categoria= this._translate.get('ence.conditions-cat-bro').toString();
            this.volumen="Sin compromiso";
            this.fidelidad="Sin fidelidad";
          }else if(this.infoClient.level.id==='8'){
            this.volumenView=false;
            this.fidelidadView=true;
            this.categoria= this._translate.get('ence.conditions-cat-oroc').toString();
            this.fidelidad='100% Fiel';
          }
          this.mail = 'asociaciones@ence.es';
          this.mailHref = 'mailto:asociaciones@ence.es';
          if (this.actualLanguage == 'es') {
            this.planCompromiso = 'Plan compromiso volumen mensual';
          } else {
            this.planCompromiso = 'Plan de compromiso volume trimestral';
          }
      break;
      case '3':

          if(this.infoClient.level.id==='7'){
            this.aprov=true;
            this.categoria= this._translate.get('ence.conditions-cat-aprov').toString();
          }
            this.mail = 'aprovechamientos@ence.es';
            this.mailHref = 'mailto:aprovechamientos@ence.es';          
      break;
    }
    
  }

}
